import type { DemoKey } from './keys';

export const uk: Partial<Record<DemoKey, string>> = {
  'app.eyebrow': 'Геометрія · 3D',
  'panel.figure': 'Фігура',
  'panel.dims': 'Розміри',
  'panel.style': 'Вигляд',
  'panel.lines': 'Особливі лінії',
  'style.body': 'Тіло',
  'style.line': 'Лінія',
  'style.cut': 'Переріз',
  'style.labels': 'Мітки вершин',
  'group.face': 'Діагоналі граней / твірні',
  'group.space': 'Діагоналі / осі / медіани',
  'split.label': 'Переріз',
  'btn.animate': 'Анімація',
  'btn.reset': 'Скинути',
  'hint.line1': 'Перетягніть для обертання · Прокрутіть для масштабу',
  'hint.line2': 'Клацніть лінію для вибору',
  'fig.cuboid': 'Прямокутний паралелепіпед',
  'fig.cube': 'Куб',
  'fig.triPrism': 'Трикутна призма',
  'fig.hexPrism': 'Шестикутна призма',
  'fig.tetrahedron': 'Тетраедр',
  'fig.squarePyramid': 'Чотирикутна піраміда',
  'fig.cylinder': 'Циліндр',
  'fig.cone': 'Конус',
  'fig.sphere': 'Сфера',
  'fig.frustumPyramid': 'Зрізана піраміда',
  'fig.frustumCone': 'Зрізаний конус',
  'dim.length': 'довжина',
  'dim.width': 'ширина',
  'dim.height': 'висота',
  'dim.side': 'сторона',
  'dim.radius': 'радіус',
  'dim.r1': 'нижній радіус',
  'dim.r2': 'верхній радіус',
  'dim.sideBase': 'сторона основи',
  'dim.sideTop': 'верхня сторона',
  'info.face': 'грань',
  'info.center': 'через центр',
  'info.diagonal': 'діагональ',
  'info.axial': 'осьова діагональ',
  'info.diameter': 'діаметр',
  'info.generator': 'твірна',
  'info.axis': 'вісь',
  'info.height': 'висота',
  'info.median': 'медіана',
  'info.apothem': 'апофема',
  'info.diameterBase': 'діаметр основи',
  'info.diameterTop': 'верхній діаметр',
};
